// frontend/src/components/Opportunities/CloseOpportunityModal.jsx
// Modal de cierre ganha/perdida — compartido por la ficha y la lista.
// El motivo de pérdida queda en opportunities.lost_reason (lo consumirá E2 para evals).
import React, { useState } from 'react';
import api from '../../services/api';
import toast from 'react-hot-toast';

const LOST_REASONS = ['Não faz sentido', 'Sem resposta', 'Preço', 'Outro'];

const CloseOpportunityModal = ({ opportunity, outcome, isOpen, onClose, onSuccess }) => {
  const [reason, setReason] = useState(LOST_REASONS[0]);
  const [detail, setDetail] = useState('');
  const [saving, setSaving] = useState(false);

  if (!isOpen || !opportunity || !outcome) return null;
  const isLost = outcome === 'lost';

  const handleConfirm = async () => {
    try {
      setSaving(true);
      const body = { outcome };
      if (isLost) {
        const text = detail.trim();
        body.lost_reason = reason === 'Outro'
          ? (text || 'Outro')
          : (text ? `${reason} — ${text}` : reason);
      }
      const res = await api.post(`/opportunities/${opportunity.id}/close`, body);
      if (res.data.success) {
        toast.success(isLost ? 'Oportunidade marcada como perdida' : 'Oportunidade marcada como ganha! 🏆');
        onSuccess?.();
      }
    } catch (e) {
      toast.error(e.response?.data?.message || 'Erro ao fechar oportunidade');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 p-4">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl w-full max-w-md p-6">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          {isLost ? 'Marcar como perdida' : 'Marcar como ganha'}
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-300 mb-4">{opportunity.title}</p>

        {isLost && (
          <div className="space-y-3 mb-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Motivo</label>
              <select
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                {LOST_REASONS.map(r => <option key={r} value={r}>{r}</option>)}
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Detalhe (opcional)</label>
              <textarea
                value={detail}
                onChange={(e) => setDetail(e.target.value)}
                rows={2}
                className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Contexto do motivo…"
              />
            </div>
          </div>
        )}

        <div className="flex justify-end gap-2">
          <button onClick={onClose} disabled={saving} className="px-4 py-2 text-sm border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50">
            Cancelar
          </button>
          <button
            onClick={handleConfirm}
            disabled={saving}
            className={`px-4 py-2 text-sm text-white rounded-md disabled:opacity-50 ${isLost ? 'bg-red-600 hover:bg-red-700' : 'bg-green-600 hover:bg-green-700'}`}
          >
            {saving ? 'Salvando…' : 'Confirmar'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CloseOpportunityModal;
